import { mapState } from 'pinia'

import MenuPopover from 'src/components/menu_popover/menu_popover.vue'

import { useInterfaceStore } from 'src/stores/interface.js'
import { useMergedConfigStore } from 'src/stores/merged_config.js'
import { useSyncConfigStore } from 'src/stores/sync_config.js'
import { useTimelinesStore } from 'src/stores/timelines.js'
import { useUsersStore } from 'src/stores/users.js'

const REPLIES = [
  ['all', 'settings.reply_visibility_all'],
  ['following', 'settings.reply_visibility_following_short'],
  ['self', 'settings.reply_visibility_self_short'],
]

// The timeline header's one menu: the few things people change often;
// everything else is in Settings.
export default {
  components: { MenuPopover },
  props: {
    // a menu row with its name (the phone's feed menu), not an icon
    labelled: Boolean,
  },
  computed: {
    ...mapState(useUsersStore, ['loggedIn']),
    ...mapState(useMergedConfigStore, ['mergedConfig']),
    items() {
      const save = (path, value) =>
        useSyncConfigStore().setSimplePrefAndSave({ path, value })
      // these change what the server sends, so the timelines reload
      const saveAndReload = (path, value) => {
        save(path, value)
        useTimelinesStore().requireReloadAll()
      }
      const { replyVisibility, timelinesOnlyMedia, streaming } =
        this.mergedConfig
      return [
        ...REPLIES.map(([value, label]) => ({
          key: `replies-${value}`,
          label: this.$t(label),
          radio: true,
          checked: replyVisibility === value,
          keepOpen: true,
          hidden: !this.loggedIn,
          action: () => saveAndReload('replyVisibility', value),
        })),
        { key: 'd1', divider: true, hidden: !this.loggedIn },
        {
          key: 'only-media',
          label: this.$t('settings.timelines_only_media'),
          checked: !!timelinesOnlyMedia,
          keepOpen: true,
          action: () =>
            saveAndReload('timelinesOnlyMedia', !timelinesOnlyMedia),
        },
        {
          key: 'auto-update',
          label: this.$t('settings.auto_update'),
          checked: !!streaming,
          keepOpen: true,
          action: () => save('streaming', !streaming),
        },
        { key: 'd2', divider: true },
        {
          key: 'more',
          label: this.$t('settings.word_filter_and_more'),
          icon: 'gear',
          action: () => useInterfaceStore().openSettingsModalTab('privacy'),
        },
      ]
    },
  },
}
